import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgCategoryIconDirective } from "./ng-category-icon.directive";
import { NgMarketplaceFilterIconDirective } from "./ng-marketplace-filter-icon.directive";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        NgCategoryIconDirective,
        NgMarketplaceFilterIconDirective
    ],
    exports: [
        NgCategoryIconDirective,
        NgMarketplaceFilterIconDirective
    ]
})
export class NgCategoryIconModule {
}
